<template>
  <div>
    <convocatoria-form ref="form" :id="id" @close="cerrar"> </convocatoria-form>
    <v-card>
      <v-card-title>Convocatorias</v-card-title>
      <v-card-text>
        <v-row>
          <v-col align="left">
            <v-btn @click="newItem" color="primary">Nueva Convocatoria</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              label="Buscar"
              v-model="search.tag"
              clearable
              @click:clear="reload"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-data-table
          v-model="selectedItems"
          :loading="loading.status"
          :items="convocatorias"
          :headers="headers"
          :server-items-length="pagination.totalCount"
          :options.sync="options"
        >
          <template v-slot:body.prepend>
            <filter-row ref="filterRow" :headers="headers" @reload="reload">
              <template v-slot:anio="{}">
                <v-select
                  outlined
                  dense
                  hide-details
                  clearable
                  @change="reload"
                  v-model="filters['anio']"
                  :items="anios"
                ></v-select>
              </template>
              <template v-slot:estado="{}">
                <v-select
                  outlined
                  dense
                  hide-details
                  clearable
                  @change="reload"
                  v-model="filters['estado']"
                  :items="estados"
                  item-text="text"
                  item-value="value"
                ></v-select>
              </template>
            </filter-row>
          </template>

          <template v-slot:item.vigente="{ item }">
            <v-chip :color="item.vigente ? 'success' : 'grey'" small dark>
              {{ item.vigente ? "Vigente" : "Cerrada" }}
            </v-chip>
          </template>

          <template v-slot:item.estado="{ item }">
            <v-chip :color="item.estado ? 'primary' : 'grey'" small dark>
              {{ item.estado ? "Activo" : "Inactivo" }}
            </v-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon color="info" class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon color="error" @click="deleteItem(item.id)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import FilterRow from "@/viewsNew/utils/FilterRow";
import { mapMutations, mapActions, mapState } from "vuex";
import ConvocatoriaForm from "@/viewsNew/convocatoria/ConvocatoriaForm";

export default {
  name: "ConvocatoriaABM",
  components: { ConvocatoriaForm, FilterRow },
  data() {
    return {
      filters: {},
      selectedItems: [],
      dialog: false,
      id: null,
      options: {},
      anios: [2030, 2029, 2028, 2027, 2026, 2025, 2024, 2023, 2022, 2021, 2020],
      estados: [
        { text: "Activo", value: 1 },
        { text: "Inactivo", value: 0 },
      ],
    };
  },
  computed: {
    ...mapState("ConvocatoriaModule", ["convocatorias", "pagination"]),
    ...mapState(["search", "loading"]),

    headers() {
      return [
        { text: "Nº", value: "numero", filterable: true },
        { text: "Año", value: "anio", filterable: true },
        { text: "Formación", value: "formacion", filterable: true },
        { text: "Carrera", value: "carrera", filterable: true },
        {
          text: "Unidad Curricular",
          value: "unidad_curricular",
          filterable: true,
        },
        {
          text: "Inicio",
          value: "fechaInicioFormateada",
          filterable: false,
          nosearch: true,
        },
        {
          text: "Fin",
          value: "fechaFinFormateada",
          filterable: false,
          nosearch: true,
        },
        {
          text: "Vigente",
          value: "vigente",
          filterable: false,
          nosearch: true,
        },
        { text: "Estado", value: "estado", filterable: true },
        {
          text: "Acciones",
          value: "actions",
          filterable: false,
          nosearch: true,
        },
      ];
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.$refs.form.resetModel();
        this.id = null;
      }
    },
    filters: {
      handler() {
        this.setFilters();
        this.reload();
      },
      deep: true,
    },
    search: {
      handler() {
        this.setSearch();
        this.reload();
      },
      deep: true,
    },
    options: {
      handler() {
        this.reload();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("ConvocatoriaModule", [
      "getConvocatorias",
      "deleteConvocatoria",
    ]),
    ...mapMutations(["clearFilters", "setFilters", "setSearch"]),

    newItem() {
      this.$refs.form.resetModel();
      this.$refs.form.dialog = true;
    },

    cerrar() {
      this.$refs.form.dialog = false;
      this.reload();
    },

    editItem(item) {
      this.id = item.id;
      this.$refs.form.dialog = true;
    },

    async deleteItem(id) {
      const res = await this.$dialog.confirm({
        color: "error",
        icon: "mdi-alert",
        text: "¿Está seguro que desea eliminar esta convocatoria?",
        title: "Eliminar Convocatoria",
      });
      if (res) {
        await this.deleteConvocatoria(id);
        this.reload();
      }
    },

    async reload() {
      this.loading.status = true;
      await this.getConvocatorias({
        like: this.$refs.filterRow?.like || {},
        options: this.options,
        filters: this.filters,
        search: this.search.tag,
        headers: this.headers,
      });
      this.loading.status = false;
    },
  },
  destroyed() {
    this.clearFilters();
  },
  created() {
    this.reload();
  },
};
</script>

<style scoped></style>
